module.exports = __webpack_public_path__ + "img/DSC_9216.7ce588af.jpg";